import styled from "styled-components";

const StyledRateIconContainer = styled.div`
  display: flex;
  align-items: center;
  color: black;
`;

export default StyledRateIconContainer;
